/** Canonical article URL path (slug is URL-encoded for the segment). */
export function articlePath(slug: string): string {
  return `/article/${encodeURIComponent(slug)}`;
}

const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when the dynamic segment looks like a Sanity document id (UUID style). */
export function urlSegmentLooksLikeUuid(segment: string): boolean {
  return UUID_SEGMENT.test(segment.trim());
}
